<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-09 12:32:57
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-31 11:49:24
 * @name: 新增修改弹窗
 * @Description: 新增修改弹窗
 * @FilePath: \preSaleNafterSaleBackstage\src\components\mailList\dialog\addNeditDialog.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="60%"
    @close="close"
  >
    <div class="head">
      <font>{{ barTitle }}</font>
    </div>
    <div class="form">
      <slot name="form"/>
    </div>
    <div class="btnGroup">
      <slot name="btnGroup"/>
    </div>
    <slot />
  </el-dialog>
</template>
<script>
export default {
  name: "mailList-Content-addNeditDialog",
  props: {
    // 标题
    title: {
      type: String,
      required: true,
    },
    // 小标题
    barTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dialogVisible: false, //弹窗显隐
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开dialog
     */  
    open() {
      this.dialogVisible = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 关闭dialog
     */  
    close() {
      this.dialogVisible = false;
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 40px;
  background: $Vars-background-bar-normal;
  box-sizing: border-box;
  padding: 0 20px;
  @extend .extend-flex-start;
}
.form {
  padding: 30px;
  width: 100%;
  box-sizing: border-box;
  @extend .extend-flex-column-center;
}
.btnGroup {
  width: 100%;
  @extend .extend-flex-center;
}
</style>
